module.exports = __webpack_public_path__ + "img/0Q3A6078_L_Wood_MockedUp.96464d83.jpg";